import { render, staticRenderFns } from "./guard_config_detail.vue?vue&type=template&id=0d1fa929&scoped=true"
import script from "./guard_config_detail.vue?vue&type=script&lang=js"
export * from "./guard_config_detail.vue?vue&type=script&lang=js"
import style0 from "./guard_config_detail.vue?vue&type=style&index=0&id=0d1fa929&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1fa929",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d1fa929')) {
      api.createRecord('0d1fa929', component.options)
    } else {
      api.reload('0d1fa929', component.options)
    }
    module.hot.accept("./guard_config_detail.vue?vue&type=template&id=0d1fa929&scoped=true", function () {
      api.rerender('0d1fa929', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/config/guard_config_detail.vue"
export default component.exports